import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import Hero from "@/components/layout/Hero";
import { useAuth } from "@/components/auth/AuthProvider";

const EngagementGrowth = lazy(() => import("@/components/layout/EngagementGrowth"));
const Stats = lazy(() => import("@/components/layout/Stats"));
const Features = lazy(() => import("@/components/layout/Features"));
const Process = lazy(() => import("@/components/layout/Process"));
const Testimonials = lazy(() => import("@/components/layout/Testimonials"));
const Graph = lazy(() => import("@/components/layout/Graph"));
const Faq = lazy(() => import("@/components/layout/Faq"));
const VerifiedBy = lazy(() => import("@/components/layout/VerifiedBy"));
const CTA = lazy(() => import("@/components/LandingPage/CTA"));

export const Route = createFileRoute("/$lang/")({
  component: LangHomepage,
});

function LangHomepage() {
  const { isRedirecting } = useAuth();

  return (
    <div className="min-h-screen relative overflow-hidden bg-white dark:bg-black transition-colors duration-300">
      <div className="absolute inset-0 bg-white/50 dark:bg-black/20 [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] pointer-events-none"></div>

      <div className="relative z-10">
        <Hero />
        {!isRedirecting && (
          <Suspense fallback={null}>
            <div className="sm:-mt-0 ">
              <EngagementGrowth />
              <Stats />
              <Process />
              <Features />
              <Testimonials />
              <Graph />
              <Faq />
              <VerifiedBy />
              <CTA />
            </div>
          </Suspense>
        )}
      </div>
    </div>
  );
}
